import React, { useState } from 'react';
import { findExamCatalogItem, LEVEL_LABELS, LEVEL_SHORT_LABELS } from '../utils/examCatalog';
import './ExamBadge.css';

interface Props {
  code?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /** 시험 유형에 등록한 아이콘 이미지 URL. 있으면 이걸 우선 쓰고, 못 불러오면 자체 배지로 대신합니다 */
  icon?: string | null;
}

/**
 * 시험 아이콘: 시험 유형 관리에서 등록한 아이콘(icon)이 있으면 그 이미지를,
 * 없거나 못 불러오면 등급 색과 시험 코드로 만든 자체 배지를 보여 줍니다.
 * 둘 다 없으면 null을 돌려줘서 호출부가 기본 아이콘을 쓰게 합니다.
 */
const ExamBadge: React.FC<Props> = ({ code, size = 'md', className = '', icon }) => {
  const [iconFailed, setIconFailed] = useState(false);
  const item = findExamCatalogItem(code);
  if (icon && !iconFailed) {
    return (
      <img
        src={icon}
        alt={item ? `${item.code} 아이콘` : '시험 아이콘'}
        title={item ? `${item.name} (${item.code})` : undefined}
        className={`exam-badge-img exam-badge-img--${size} ${className}`.trim()}
        onError={() => setIconFailed(true)}
      />
    );
  }
  if (!item) return null;
  const [series, version] = item.code.split('-');
  return (
    <span
      className={`exam-badge exam-badge--${item.level} exam-badge--${size} ${className}`.trim()}
      role="img"
      aria-label={`${item.code} · ${LEVEL_LABELS[item.level]}`}
      title={`${item.name} (${item.code})`}
    >
      <span className="exam-badge__level">{LEVEL_SHORT_LABELS[item.level]}</span>
      <span className="exam-badge__code">{series}</span>
      <span className="exam-badge__version">{version}</span>
    </span>
  );
};

export default ExamBadge;
